export default function title(pageContext) {
    return pageContext?.data?.meta?.title || "NGUD WALK";
}
